export const checkIfIsUrl = (str: string) => {
  const a = document.createElement('a');
  a.href = str;
  return a.host && a.host !== window.location.host;
};
